__turbopack_context__.v({
  "container": "FacebookTaxWidget-module-scss-module__9wzXuq__container",
});
